export interface IUserAccount {
    accountId: number;
    referenceId: number;
    encryptedReferenceId: string;
    roleId: number;
    roleName: string;
    fullName: string;
    email: string;
    mobile: string;
    countryId: number;
    countryName: string;
    countryCode: string;
    sessionId?: number;
    lastLoginDate?: Date;
    thumbnailUrl: string;
    isAgreed: boolean;
    token: string;
    expires: Date;
    referenceToken: string;
    deviceId: string;
    allowVideoCall: boolean;
    locationId: number;
    locationName: string;
    roleDepartments?: Array<string>;
    departmentIds: number[];
}